import { render } from "./IntakeFormPrintTemplate.vue?vue&type=template&id=4ecdd180&scoped=true"
import script from "./IntakeFormPrintTemplate.vue?vue&type=script&lang=js"
export * from "./IntakeFormPrintTemplate.vue?vue&type=script&lang=js"

import "./IntakeFormPrintTemplate.vue?vue&type=style&index=0&id=4ecdd180&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ecdd180"]])

export default __exports__